var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_12768",
    "data-name": "Group 12768",
    transform: "translate(-1389 -476)",
    style: {
      isolation: "isolate"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1386",
    "data-name": "Ellipse 1386",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1389 476)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1386_-_Outline",
    "data-name": "Ellipse 1386 - Outline",
    d: "M10,1.3A8.7,8.7,0,1,0,18.7,10,8.71,8.71,0,0,0,10,1.3M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(1389 476)",
    fill: "#00ac94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27508",
    "data-name": "Path 27508",
    d: "M2.189,0H.858V-5.753H2.189Zm.143-7.436a.763.763,0,0,1-.242.594.822.822,0,0,1-.572.22.836.836,0,0,1-.583-.22.763.763,0,0,1-.242-.594.777.777,0,0,1,.242-.605.836.836,0,0,1,.583-.22.822.822,0,0,1,.572.22A.777.777,0,0,1,2.332-7.436Z",
    transform: "translate(1398 490)",
    fill: "#00ac94"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.d014a2220c636090ed724890c0f8278d.svg";
export { ForwardRef as ReactComponent };